// This file is used by webpack to replace 'react' imports from ui-library
// It re-exports React with useSyncExternalStore added
// We use a direct import to avoid webpack warnings about dynamic requires

// Import React directly - webpack will resolve this correctly
// eslint-disable-next-line @typescript-eslint/no-require-imports
const ReactOriginal = require('react');
// eslint-disable-next-line @typescript-eslint/no-require-imports
const { useSyncExternalStore } = require('use-sync-external-store/shim');

// Create a new object with all React exports plus useSyncExternalStore
const ReactWithPolyfill = { ...ReactOriginal };
ReactWithPolyfill.useSyncExternalStore = useSyncExternalStore;

// Export everything
module.exports = ReactWithPolyfill;

